import { useRef } from "react";

export default function useScroll() {
    const scrollRef = useRef(null);
    const executeScroll = () => scrollRef.current.scrollIntoView();
    
    return [executeScroll, scrollRef];
}
